<template>
  <div class="side-navigation-container">
    <h1
      v-if="title"
      class="
        private-policy__title
        txt--bold txt--36px txt--height-44px
        txt--color-04 txt--52px--l txt--height-64px--l
        mb-28
      "
    >
      {{ title }}
    </h1>
    <div
      v-if="lastUpdate"
      class="private-policy__date txt txt--14px txt--color-03 mb-30"
      v-text="lastUpdate"
    />
    <div class="side-navigation-container__content">
      <div
        class="side-navigation-container__navigation"
        :class="{
          'side-navigation-container__navigation--without-bg': withoutBg,
        }"
      >
        <div class="side-navigation-container__navigation-inner">
          <slot name="navigation" />
        </div>
      </div>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideNavigationContainer',
  components: {},
  props: {
    title: { type: String, default: '' },
    lastUpdate: {
      type: String,
      default: '',
    },
    withoutBg: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.side-navigation-container {
  $root: &;

  &__content {
    display: grid;
    gap: toRem(40px);

    @include bp(l) {
      grid-template-columns: 1fr 2.5fr;
      gap: toRem(30px);
    }
  }

  &__navigation-inner {
    overflow: auto;
    padding-right: toRem(18px);

    @include bp(l) {
      padding-top: toRem(20px);
      width: 100%;
    }
  }

  &__navigation {
    overflow: auto;

    @include bp(l) {
      display: inline-flex;
      max-height: 70vh;
      min-height: 10vh;
      height: fit-content;
      position: sticky;
      top: toRem(92px);
      right: toRem(12px);
      box-shadow: map-get($shadows, '03');
      border-radius: toRem(12px);
      background: color('color-02');
      padding: 0 toRem(2px) 0 toRem(20px);
    }

    &--without-bg {
      border-radius: 0;
      background: none;
      padding: 0;
      box-shadow: none;

      #{$root}__navigation-inner {
        padding-top: 0;
        width: fit-content;
      }
    }
  }

  ::v-deep {
    ol,
    ul {
      margin-bottom: toRem(16px);
      padding-left: toRem(16px);
    }
  }
}
</style>
